import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AskNaviChatComponent,
  AskNaviChatStateService,
  ConversationSidebarComponent,
} from '@brighthub/ask-navi-ui';

/**
 * Shell layout for the Ask Navi subapp: conversation sidebar plus main chat panel.
 */
@Component({
  selector: 'an-ask-navi-layout',
  standalone: true,
  imports: [CommonModule, ConversationSidebarComponent, AskNaviChatComponent],
  templateUrl: './ask-navi-layout.component.html',
  styleUrl: './ask-navi-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AskNaviLayoutComponent implements OnInit {
  private readonly _state = inject(AskNaviChatStateService);

  ngOnInit(): void {
    void this._state.loadConversations();
  }
}
